module.exports = __webpack_public_path__ + "static/bannerTeam-e15185e031163b4476e4c8e5df36becf.jpg";